enum PodcastColorTypes {
  HeadingText = "heading-text",
  ParagraphText = "paragraph-text",
  HeaderBackground = "header-background",
  HeaderText = "header-text",
  FooterBackground = "footer-background",
  FooterText = "footer-text",
  PlaybarBackground = "playbar-background",
  PlaybarText = "playbar-text",
  BodyBackground = "body-background",
  FeaturedContentText = "featured-content-text",
  FeaturedContentBadgeOne = "featured-content-badge-one",
  FeaturedContentBadgeTwo = "featured-content-badge-two",
  EpisodeContainerBackground = "episode-container-background",
  EpisodeTitleContainerBackground = "episode-title-container-background",
  EpisodeText = "episode-text",
  EpisodeTimeText = "episode-time-text",
  EpisodeModalText = "episode-modal-text",
  EpisodeModalBackground = "episode-modal-background",
  EpisodeModalBadgeOne = "episode-modal-badge-one",
  EpisodeModalBadgeTwo = "episode-modal-badge-two",
  IconsBackground = "icons-background",
  Icons = "icons",
  MediaTrack = "media-track",
  MediaFilledTrack = "media-filled-track",
  DetailsMediaTrack = "details-media-track",
  DetailsMediaFilledTrack = "details-media-filled-track",
  MediaTooltipBackground = "media-tooltip-background",
  VolumeTrack = "volume-track",
  VolumeFilledTrack = "volume-filled-track"
}

export default PodcastColorTypes;
